import { useRequest } from '@hourly/hooks/useRequest';
import { useState } from 'react';
import { BankAccount } from '../models/BankAccount';
import { getBankAccount } from '../requests/bankAccount.request';

export function useGetBankAccount(partnerId: string) {
  const [bankAccount, setBankAccount] = useState<BankAccount | undefined>();

  const { request: fetchBankAccount, status } = useRequest(
    async () => {
      if (!partnerId) {
        return;
      }
      setBankAccount(await getBankAccount(partnerId));
    },
    { requestOnMount: true }
  );

  return { bankAccount, fetchBankAccount, isSettled: status.isError || status.isSuccess };
}
